<!-- The export window (CR-20260930-001 M2; owner vrequest 2026-09-30): section → underlying → order block.
     Export one order, an underlying chain, a section, or all pending orders in the window.
     Height (owner 2026-09-30): fits its content up to 80% of the screen, then the body scrolls. -->
<dx-popup [visible]="this.visible" [width]="this.width" height="auto" maxHeight="80vh" [showTitle]="true" [title]="this.title" [wrapperAttr]="this.popupWrapperAttr"
          [closeOnOutsideClick]="false" [showCloseButton]="false" [resizeEnabled]="true" [dragEnabled]="true"
          (onHidden)="this.onHidden()">
  <div *dxTemplate="let data of 'content'" class="container" [class.acquire]="this.isAcquire">

    <div class="content">
      <div class="scroll">
        <div class="state">

          <ng-container *ngFor="let section of this.sections">
            <!-- The section header: the panel's own (blue, bordered, same type size). -->
            <div class="section-header">
              <span class="section-name">{{ section | uppercase }}</span>
              <i *ngIf="!this.isAcquire" class="dx-icon dx-icon-export bar-icon section-export"
                 [class.inert]="!this.canCopyMany(section)" title="Export all pending orders in this section to ToS"
                 (click)="this.onCopyMany(section)"></i>
              <!-- Acquire mode: acquire the whole section — blocked while any fill in it is missing. -->
              <span *ngIf="this.isAcquire" class="acquire-badge section-badge" [class.inert]="!this.canAcquireSection(section)"
                    [title]="this.acquireSectionTitle(section)" (click)="this.onAcquireSection(section)">A</span>
            </div>

            <div *ngFor="let g of this.groupsOf(section); trackBy: this.trackGroup" class="group">

              <!-- The underlying bar. A stock: its one block's copy / state / revoke live here.
                   Options: the chain copy (main + linked in one write) when two or more blocks pend. -->
              <div class="bar">
                <div class="name">{{ g.title }}</div>
                <ng-container *ngIf="g.isAsset && g.blocks.length">
                  <ng-container *ngTemplateOutlet="blockState; context: {b: g.blocks[0]}"></ng-container>
                </ng-container>
                <i *ngIf="this.canCopyChain(g)" class="dx-icon dx-icon-export bar-icon chain" title="Export All Pending Orders for This Underlying"
                   (click)="this.onCopyChain(g)"></i>
              </div>

              <div *ngFor="let b of g.blocks; trackBy: this.trackBlock" class="block"
                   [class.copied]="this.isCopied(b) && !this.isAcquire" [class.overdue]="b.status === 'Overdue'" [class.blocked]="!!b.blockedReason"
                   [title]="this.isAcquire ? (b.orderText || '') : ''">

                <!-- The order caption (options): "Main Order" / "Linked #1" + its own copy / state / revoke. -->
                <div class="caption" *ngIf="!g.isAsset">
                  <div class="name">{{ b.name }}</div>
                  <ng-container *ngTemplateOutlet="blockState; context: {b: b}"></ng-container>
                </div>

                <!-- Acquire mode: a partly priced block holds the Acquire button — say so. -->
                <div class="pricing-hint" *ngIf="this.pricingHint(b)">{{ this.pricingHint(b) }}</div>

                <ets-order-preview-tables [tables]="this.tablesOf(b, g.isAsset)" [isAsset]="g.isAsset"
                  [acquiring]="this.isAcquire" [busy]="this.busy"
                  (fillChanged)="this.onTableFillChanged(b, g.isAsset, $event)"></ets-order-preview-tables>

              </div>
            </div>
          </ng-container>

          <div class="empty" *ngIf="!this.groups?.length">
            {{ this.isAcquire ? 'Nothing to apply — no pending order of the Portfolio Hedging Analysis under this scope.' : 'Nothing to export — no change differs from the before state.' }}
          </div>
        </div>
      </div>
    </div>

    <!-- Export mode: Export All + Close. Acquire mode: Acquire (the fully priced blocks) + Close. -->
    <div class="footer">
      <div class="btn export" *ngIf="!this.isAcquire">
        <dx-button text="Export All" icon="export" width="100%" [disabled]="!this.canCopyMany()"
                   hint="Export all pending orders in this window to ToS" (onClick)="this.onCopyMany()"></dx-button>
      </div>
      <div class="btn acquire" *ngIf="this.isAcquire">
        <dx-button text="Acquire All" type="danger" width="100%" [disabled]="!this.canAcquireAll" [hint]="this.acquireAllTitle"
                   (onClick)="this.onAcquireAll()"></dx-button>
      </div>
      <div class="btn close">
        <dx-button text="Close" width="100%" [disabled]="this.busy" (onClick)="this.onClose()"></dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<!-- A block's state and its one action: copy (pending), or "Exported <time>" + revoke (copied).
     Acquire mode: the state, then the undo icon = Clear After State. -->
<ng-template #blockState let-b="b">
  <div class="state-text" *ngIf="this.isCopied(b)" [class.overdue]="b.status === 'Overdue'" [class.orphaned]="b.isOrphaned">
    <i class="fa" [ngClass]="b.status === 'Overdue' ? 'fa-exclamation-circle' : 'fa-shield-alt'"></i> {{ this.stateTextOf(b) }}
  </div>
  <div class="state-text blocked-reason" *ngIf="b.blockedReason && !this.isCopied(b)" [title]="b.blockedReason">
    <i class="fa fa-ban"></i> {{ b.blockedReason }}
  </div>
  <i *ngIf="!this.isCopied(b) && !this.isAcquire" class="dx-icon dx-icon-export bar-icon" [class.inert]="!this.canCopy(b)"
     title="Export this order to ToS" (click)="this.onCopy(b)"></i>
  <!-- Acquire mode: acquire THIS order — blocked while any of its legs is unpriced. -->
  <span *ngIf="this.isAcquire" class="acquire-badge" [class.inert]="!this.canAcquireBlock(b)"
        [title]="this.acquireBlockTitle(b)" (click)="this.onAcquireBlock(b)">A</span>
  <i *ngIf="this.isCopied(b)" class="fa fa-undo bar-icon" [class.inert]="this.busy"
     [title]="this.undoTitle" (click)="this.onRevoke(b)"></i>
</ng-template>
